import React, { createContext, useState, useEffect, useCallback } from 'react';
// import useLocalStorage from './hooks/useLocalStorage';
import useSessionStorage from './hooks/useSessionStorage';
import { api, loggingAPI } from './api' //Lets you set URL from which to call fetching
import { useAuth0 } from "@auth0/auth0-react";
import axios from 'axios';
import useLocalStorage from 'hooks/useLocalStorage';

// Stores all state variables used in App.js and passed down to children here
// and allows for the use of useContext in other components that would normally have to
// have it passed down as props
export const AppContext = createContext();

export const AppProvider = ({ children }) => {

	// user details 
	const { user } = useAuth0();


	// List of manufacturers
	let manListList = [];
	if (process.env.REACT_APP_BRANCH_NAME === "main") {
		manListList = [
			"Master-Bilt",
			"Norlake",
			"Pitco",
			"Southbend Range",
		];
	} else {
		manListList = [
			// "Blodgett",
			"Delfield",
			// "Federal Industries",
			"Frymaster",
			// "Hoshizaki",
			// "Jackson",
			"Master-Bilt",
			"Norlake",
			"Pitco",
			"Southbend Range",
			"Structural Concepts",
			"True",
			"Turbo Air",
			"TurboChef",
		];
	};
	const manList = manListList.map(manufacturer => ({ value: manufacturer, label: manufacturer }))
	.sort((a, b) => a.label.localeCompare(b.label)); // Sort alphabetically by label;


	// NEW SALESFORCE CODE: loading in manufacturer list from backend on app startup =================================================================================================================
	// ===============================================================================================================================================================================================
	// NOTE: TODO: Uncomment when we work with every manufacturer
	/*
	const [manList, setManList] = useLocalStorage("manList", []);
	const [manListLoading, setManListLoading] = useState(false); // Flag on whether the manufacturer list is currently being fetched
	// Fetch manufacturer list from the backend on startup
    useEffect(() => {
        const fetchDisplayNames = async () => {
            try {
				// Prevent another call if data already exists or if a request is in progress
				if (manList.length > 0 || manListLoading) {
					return;
				}
				setManListLoading(true);
                // const response = await axios.get("http://0.0.0.0:8080/api/get-display-names");
				const response = await loggingAPI.get('/api/get-display-names');
                if (response.data.status === "success") {
                    const formattedData = Object.entries(response.data.data).map(([value, label]) => ({ value, label }));
                    setManList(formattedData);  // Set the formatted data as the manufacturer list
                } else {
                    console.error("Failed to load display names:", response.data.message);
                }
            } catch (error) {
                console.error("Error fetching display names:", error);
            } finally {
				setManListLoading(false);
			}
        };

        fetchDisplayNames();
    }, []);
	*/
	// ==============================================================================================================================================================================================
	// ==============================================================================================================================================================================================



	// Auto generated ID just to keep track of the session per user
	const [sessionID, setSessionID] = useSessionStorage('sessionID', '');

	// Generate and store session ID when the component mounts
	useEffect(() => {
		const generatesessionID = () => {
			return 'session-' + Math.random().toString(36).substring(2, 17);
		};
		
		const newSessionID = generatesessionID();

		if (sessionID) {
			return;
		}

		setSessionID(newSessionID);
	}, [sessionID, setSessionID]);


	// The ID associated with the current search
	const [searchId, setSearchId] = useState(null);


	// The input values for the search bar (used to be consistent across Home Search bar and Nav Search bar)
	const [serNum, setSerNum] = useState("");
	const [modNum, setModNum] = useState("");
	const [manName, setManName] = useState("");
	const [refineQuery, setRefineQuery] = useState("");
	const [activeSearchTermFilter, setActiveSearchTermFilter] = useState("all");


	// FeedbackPanel states of like/dislike buttons and feedback text for RC, SNL, and web parts
	// Stores what each feedback panel has in terms of like/dislike buttons and feedback text currently
	// Key is mfgPartName + description due to NOT IN WEBSITE having the same ptPartName and mfgPartName for Norlake APIs
	const [feedbackPanelStatesRC, setFeedbackPanelStatesRC] = useState({});
	// Updates the dictionary of feedbackPanelStates with the new feedbackPanelStates
	// useCallback is used to prevent infinite loops from rerendering the function for each FeedbackPanel; only rerenders if the dependencies in the function change
	const handleFeedbackPanelStatesRC = useCallback((mfgPartName, description, { likeClicked, dislikeClicked, feedbackText }) => {
		setFeedbackPanelStatesRC(prevStates => ({
			...prevStates,
			[`${mfgPartName}${description}`]: { likeClicked: likeClicked, dislikeClicked: dislikeClicked, feedbackText: feedbackText }
		}));
	}, [setFeedbackPanelStatesRC]);
	const [feedbackPanelStatesSNL, setFeedbackPanelStatesSNL] = useState({});
	const handleFeedbackPanelStatesSNL = useCallback((mfgPartName, description, { likeClicked, dislikeClicked, feedbackText }) => {
		setFeedbackPanelStatesSNL(prevStates => ({
			...prevStates,
			[`${mfgPartName}${description}`]: { likeClicked: likeClicked, dislikeClicked: dislikeClicked, feedbackText: feedbackText }
		}));
	}, [setFeedbackPanelStatesSNL]);
	const [feedbackPanelStatesWeb, setFeedbackPanelStatesWeb] = useState({});
	const handleFeedbackPanelStatesWeb = useCallback((mfgPartName, description, { likeClicked, dislikeClicked, feedbackText }) => {
		setFeedbackPanelStatesWeb(prevStates => ({
			...prevStates,
			[`${mfgPartName}${description}`]: { likeClicked: likeClicked, dislikeClicked: dislikeClicked, feedbackText: feedbackText }
		}));
	}, [setFeedbackPanelStatesWeb]);
	const [feedbackPanelStatesParsed, setFeedbackPanelStatesParsed] = useState({});
	const handleFeedbackPanelStatesParsed = useCallback((mfgPartName, description, { likeClicked, dislikeClicked, feedbackText }) => {
		setFeedbackPanelStatesParsed(prevStates => ({
			...prevStates,
			[`${mfgPartName}${description}`]: { likeClicked: likeClicked, dislikeClicked: dislikeClicked, feedbackText: feedbackText }
		}));
	}, [setFeedbackPanelStatesParsed]);
	const [feedbackPanelStatesAll, setFeedbackPanelStatesAll] = useState({});
	const handleFeedbackPanelStatesAll = useCallback((mfgPartName, description, { likeClicked, dislikeClicked, feedbackText }) => {
		setFeedbackPanelStatesAll(prevStates => ({
			...prevStates,
			[`${mfgPartName}${description}`]: { likeClicked, dislikeClicked, feedbackText }
		}));
	}, [setFeedbackPanelStatesAll]);


	//Submits the feedback taken from the feedback form
	const logFeedbackHandler = async (
		typeOfResult,
		optPartDesc,
		mfgName,
		repPartName,
		ptPartName,
		mfgPartName,
		partDesc,
		imgURL,
		partObsolete,
		notes,
		liked,
		feedbackText,
		correctPart = "",
		dislikedCategory = ""
	) => {
		const feedbackData = {
			searchID: searchId,
			typeOfResult: typeOfResult,
			optPartDesc: optPartDesc,
			mfgName: mfgName,
			repPartName: repPartName,
			ptPartName: ptPartName,
			mfgPartName: mfgPartName,
			partDesc: partDesc,
			imgURL: imgURL,
			partObsolete: partObsolete,
			notes: notes,
			liked: liked,
			feedbackText: feedbackText,
			correct_part: correctPart || "",
			disliked_category: dislikedCategory || "",
		};
		try {
			const response = await loggingAPI.post(`/api/logfeedback`, feedbackData);
			console.log("Feedback logging: ", response.data);
		} catch (error) {
			if (error.response) {
				// The request was made and the server responded with a status code
				// that falls out of the range of 2xx
				console.error('Error response:', error.response);
			} else if (error.request) {
				// The request was made but no response was received
				console.error('Error request:', error.request);
			} else {
				// Something happened in setting up the request that triggered an Error
				console.error('Error message:', error.message);
			}
		}
	};
	//Submits the feedback taken from the feedback form
	const logSearchHandler = async (mfgInput, mnInput, snInput, queryInput) => {
		const searchData = {
			userName: user.preferred_username,
			sessionID: sessionID,
			mfgInput: mfgInput,
			mnInput: mnInput,
			snInput: snInput,
			queryInput: queryInput
		};
		try {
			const source = axios.CancelToken.source();
			const timeout = setTimeout(() => {
				source.cancel();
			}, 2000);
			const response = await loggingAPI.post(`/api/logsearch`, searchData);
			clearTimeout(timeout);
			console.log("Search logging: ", response.data, typeof(response.data.searchid));

			if (typeof response.data.searchid === 'number') {
				const newSearchId = response.data.searchid;
				console.log("DONESEARCHHANDLERBBB", newSearchId);
				return Promise.resolve(newSearchId);
			} else {
				throw new Error('Search ID is not a number');
			}

		} catch (error) {
			if (error.response) {
				// The request was made and the server responded with a status code
				// that falls out of the range of 2xx
				console.error('Error response:', error.response);
			} else if (error.request) {
				// The request was made but no response was received
				console.error('Error request:', error.request);
			} else {
				// Something happened in setting up the request that triggered an Error
				console.error('Error message:', error.message);
			}
			return Promise.reject(-1);
		}
	};

	//Submits the results from an endpoint
	// TODO(joan): Added parsed results
	const logResultsHandler = async (
		newSearchID,
		newCasesList,
		newRCResults,
		newSNLResults,
		newWebResults,
		newParsedResults,
		newManResults,
		newConsolidatedResults = null
	) => {
		const casesData = {
			searchID: newSearchID,
			casesList: newCasesList,
			rcResults: newRCResults,
			snlResults: newSNLResults,
			webResults: newWebResults,
			parsedResults: newParsedResults,
			manResults: newManResults,
			consolidatedResults: newConsolidatedResults,
		};
		try {
			console.log("Sending out:\n", casesData);
			const response = await loggingAPI.post(`/api/logresults`, casesData);
			console.log("Results logging: ", response.data);
		} catch (error) {
			if (error.response) {
				// The request was made and the server responded with a status code
				// that falls out of the range of 2xx
				console.error('Error response:', error.response);
			} else if (error.request) {
				// The request was made but no response was received
				console.error('Error request:', error.request);
			} else {
				// Something happened in setting up the request that triggered an Error
				console.error('Error message:', error.message);
			}
		}
	};

	// TODO: check all traceback is needed
	//Returned search result manuals, parts, and BF posts based on serial number search
	const [searchResultsManuals, setSearchResultsManuals] = useSessionStorage('searchResultsManuals', {});
	const [searchResultsManualsTraceback, setSearchResultsManualsTraceback] = useSessionStorage('searchResultsManualsTraceback', {});
	//const [searchResultsParts, setSearchResultsParts] = useSessionStorage('searchResultsParts', {});
	const [searchResultsBF, setSearchResultsBF] = useSessionStorage('searchResultsBF', {});
	const [searchResultsBFTraceback, setSearchResultsBFTraceback] = useSessionStorage('searchResultsBFTraceback', {});

	//Parts results returned via resolved cases and serial number lookup respectively
	const [searchResultsPartsRC, setSearchResultsPartsRC] = useSessionStorage('searchResultsPartsRC', {});
	const [searchResultsPartsRCTraceback, setSearchResultsPartsRCTraceback] = useSessionStorage('searchResultsPartsRCTraceback', {});
	// The exact match boolean parameter for the resolved cases result
	const [searchResultsPartsSNL, setSearchResultsPartsSNL] = useSessionStorage('searchResultsPartsSNL', {});
	const [searchResultsPartsSNLTraceback, setSearchResultsPartsSNLTraceback] = useSessionStorage('searchResultsPartsSNLTraceback', {});

	// NEW: Website data
	const [searchResultsPartsWebsite, setSearchResultsPartsWebsite] = useSessionStorage('searchResultsPartsWebsite', {});
	const [searchResultsPartsWebsiteTraceback, setSearchResultsPartsWebsiteTraceback] = useSessionStorage('searchResultsPartsWebsiteTraceback', {});

	// NEW: Parsed data from PDF manuals
	const [searchResultsPartsParsed, setSearchResultsPartsParsed] = useSessionStorage('searchResultsPartsParsed', {});
	const [searchResultsPartsTraceback, setSearchResultsPartsTraceback] = useSessionStorage('searchResultsPartsTraceback', {});
		const [searchResultsPartsAll, setSearchResultsPartsAll] = useSessionStorage('searchResultsPartsAll', {});
		const [searchResultsPartsAllTraceback, setSearchResultsPartsAllTraceback] = useSessionStorage('searchResultsPartsAllTraceback', {});

	
		//Whether a call is being fetched or not. The number = # of API calls being fetched at the moment
		const [isLoading, setIsLoading] = useState(0);
		const [isConsolidatedLoading, setIsConsolidatedLoading] = useState(false);

	//Stores the keepSRBlank in local storage
	// Whether the app should keep the search results blank (true)
	// or show search results (i.e "No Results" or cards)
	const [keepSRBlank, setKeepSRBlank] = useSessionStorage('keepSRBlank', true);
	const [resultsViewMode, setResultsViewMode] = useSessionStorage('resultsViewMode', 'consolidated');

	// Active filter for data source dropdown (used in consolidated and new views)
	const [activeFilter, setActiveFilter] = useSessionStorage('activeFilter', 'all');

	const normaliseSearchTerm = (term) => (typeof term === "string" ? term.trim().toLowerCase() : "");

	useEffect(() => {
		const queriesFromResults = Array.isArray(searchResultsPartsAll?.refineQueries)
			? searchResultsPartsAll.refineQueries.filter((entry) => typeof entry === "string" && entry.trim().length > 0)
			: [];
		const queriesFromInput = typeof refineQuery === "string"
			? refineQuery.split(",").map((entry) => entry.trim()).filter((entry) => entry.length > 0)
			: [];

		const availableQueries = queriesFromResults.length > 0 ? queriesFromResults : queriesFromInput;

		if (availableQueries.length === 0) {
			if (activeSearchTermFilter !== "all") {
				setActiveSearchTermFilter("all");
			}
			return;
		}

		setActiveSearchTermFilter((prev) => {
			if (prev === "all") {
				return prev;
			}

			const normalisedPrev = normaliseSearchTerm(prev);
			const hasPrev = availableQueries.some((query) => normaliseSearchTerm(query) === normalisedPrev);
			return hasPrev ? prev : availableQueries[0];
		});
	}, [searchResultsPartsAll, refineQuery, activeSearchTermFilter]);

	//Searches for manuals from serial Numbers
	const snToManuals = async (ser_num, mod_num, manName) => {
		// URL encodes the inputs
		ser_num = encodeURIComponent(ser_num);
		mod_num = encodeURIComponent(mod_num);
		manName = encodeURIComponent(manName);

		try {
			const source = axios.CancelToken.source();
			const timeout = setTimeout(() => {
				source.cancel();
			}, 10000);
			const response = await api.get(`/api/manuals/?ser_num=${ser_num}&mod_num=${mod_num}&mfg_name=${manName}`);
			clearTimeout(timeout);

			return Promise.resolve({
				parts: response.data.manuals,
				isError: false,
				errorMessage: "",
				emptyTraceback: response.data.emptyTraceback
			});
			
		} catch (error) {

			var retManData = {};
			var errorMessage = "Unknown error";
			if (axios.isCancel(error)) {
				retManData = {"":[]};
				errorMessage = "Request timed out";
			} else {
				retManData = error.response.data.detail.renderData.manuals;
				errorMessage = error.response.data.detail.message;
			}

			if (error.response) {
				// The request was made and the server responded with a status code
				// that falls out of the range of 2xx
				console.error('Error response:', error.response);
			} else if (error.request) {
				// The request was made but no response was received
				console.error('Error request:', error.request);
			} else {
				// Something happened in setting up the request that triggered an Error
				console.error('Error message:', error.message);
			}
			
			// Returns rejected promise to at least signal that the async function ended
			return Promise.resolve({
				parts: retManData,
				isError: true,
				errorMessage: errorMessage,
				emptyTraceback: error.response.data.detail.renderData.emptyTraceback
			});
		} finally {
			console.log("Manual returned")
		}
	};

	// Fetches consolidated parts list (candidates + refined)
	const snToPartsAll = async (ser_num, mod_num, manName, refine_query) => {
		const enc_ser_num = ser_num ? encodeURIComponent(ser_num) : "";
		const enc_mod_num = mod_num ? encodeURIComponent(mod_num) : "";
		const enc_mfg_name = manName ? encodeURIComponent(manName) : "";
		const enc_refine_query = refine_query ? encodeURIComponent(refine_query) : "";

		const queryString = `/api/candidate_list/?ser_num=${enc_ser_num}&mod_num=${enc_mod_num}&mfg_name=${enc_mfg_name}&refine_query=${enc_refine_query}`;

		let candidateData = { numberOfCases: 0, casesList: [], parts: [] };
		let refinedData = { parts: [] };
		let consolidatedErrorMessage = "";
		let consolidatedHasError = false;

		const candidateSource = axios.CancelToken.source();
	const candidateTimeout = setTimeout(() => {
		candidateSource.cancel('candidate_list_request_timeout');
	}, 45000);

		try {
			const candidateResponse = await api.get(queryString, {
				cancelToken: candidateSource.token,
			});

			candidateData = candidateResponse.data ?? candidateData;
		} catch (error) {
			if (axios.isCancel(error)) {
				const timeoutMessage = error.message === 'candidate_list_request_timeout'
					? "Candidate request timed out"
					: error.message;
				consolidatedErrorMessage = timeoutMessage ?? "Candidate request timed out";
				console.warn("Consolidated candidate request cancelled:", {
					url: queryString,
					message: timeoutMessage,
				});
			} else if (error.response) {
				consolidatedErrorMessage = error.response.data?.detail?.message ?? error.response.data?.detail ?? error.response.statusText ?? "Candidate request failed";
				console.error("Consolidated candidate request failed with response:", {
					status: error.response.status,
					statusText: error.response.statusText,
					data: error.response.data,
				});
			} else if (error.request) {
				consolidatedErrorMessage = "No response received for consolidated parts request";
				console.error("Consolidated candidate request made but no response received:", {
					url: queryString,
					code: error.code,
					message: error.message,
				});
			} else {
				consolidatedErrorMessage = error.message ?? "Unknown error";
				console.error("Unexpected consolidated candidate request error:", error);
			}

			consolidatedHasError = true;
			return Promise.resolve({
				numberOfCases: candidateData.numberOfCases,
				casesList: candidateData.casesList,
				parts: candidateData.parts ?? [],
				bf_links: candidateData?.bf_links ?? null,
				candidates: candidateData,
				isError: true,
				errorMessage: consolidatedErrorMessage,
				emptyTraceback: "",
			});
		} finally {
			clearTimeout(candidateTimeout);
		}

	const sanitisedCandidateParts = Array.isArray(candidateData?.parts)
		? candidateData.parts.reduce((acc, part) => {
			if (!part || typeof part !== "object") {
				return acc;
			}

			const {
				mfgstockcode,
				stockcode,
				optimizeddescription,
				description,
				data_source,
				data_sources,
			} = part;

			const identifier = mfgstockcode || stockcode || optimizeddescription || description;

			if (!identifier || identifier.toString().trim() === "") {
				return acc;
			}

			const rawSources = Array.isArray(data_sources)
				? data_sources
				: data_source
					? Array.isArray(data_source)
						? data_source
						: [data_source]
					: [];

			const normalisedSources = rawSources
				.map((source) => (source || "").toString().trim().toLowerCase())
				.filter((source) => source !== "");

			const hydratedPart = {
				...part,
				data_sources: normalisedSources.length > 0 ? normalisedSources : ["unknown"],
			};

			acc.push(hydratedPart);
			return acc;
		}, [])
		: [];

	const sanitisedCandidateData = {
		...candidateData,
		numberOfCases: typeof candidateData?.numberOfCases === "number" ? candidateData.numberOfCases : 0,
		casesList: Array.isArray(candidateData?.casesList) ? candidateData.casesList : [],
		parts: sanitisedCandidateParts,
	};

		if (!sanitisedCandidateData.parts.length) {
			return Promise.resolve({
				numberOfCases: sanitisedCandidateData.numberOfCases,
				casesList: sanitisedCandidateData.casesList,
				parts: [],
				bf_links: sanitisedCandidateData?.bf_links ?? null,
				candidates: sanitisedCandidateData,
				refined: [],
				refineQueries: [],
				isError: consolidatedHasError,
				errorMessage: consolidatedErrorMessage,
				emptyTraceback: "",
			});
		}

		const refineTokens = Array.isArray(refine_query)
			? refine_query.filter((entry) => typeof entry === "string" && entry.trim().length > 0)
			: (refine_query
				? `${refine_query}`.split(",").map((entry) => entry.trim()).filter(Boolean)
				: []);

		const refineQueryParam = refineTokens.length ? refineTokens.join(",") : "";

		if (refineQueryParam !== "") {
			const refineSource = axios.CancelToken.source();
		const refineTimeout = setTimeout(() => {
			refineSource.cancel('refine_parts_request_timeout');
		}, 45000);

			try {
				const refineEndpoint = `/api/refine_parts/?refine_query=${encodeURIComponent(refineQueryParam)}`;

				const refineResponse = await api.post(refineEndpoint, sanitisedCandidateData, {
					cancelToken: refineSource.token,
				});

			refinedData = refineResponse.data ?? refinedData;
		} catch (error) {
			if (axios.isCancel(error)) {
				const timeoutMessage = error.message === 'refine_parts_request_timeout'
					? "Refine request timed out"
					: error.message;
				consolidatedErrorMessage = timeoutMessage ?? "Refine request timed out";
				console.warn("Consolidated refine request cancelled:", {
					url: `/api/refine_parts/?refine_query=${encodeURIComponent(refineQueryParam)}`,
					message: timeoutMessage,
				});
			} else if (error.response) {
				consolidatedErrorMessage = error.response.data?.detail?.message ?? error.response.data?.detail ?? error.response.statusText ?? "Refine request failed";
				console.error("Consolidated refine request failed with response:", {
					status: error.response.status,
					statusText: error.response.statusText,
					data: error.response.data,
				});
			} else if (error.request) {
				consolidatedErrorMessage = "No response received for refine request";
				console.error("Consolidated refine request made but no response received:", {
					code: error.code,
					message: error.message,
				});
			} else {
				consolidatedErrorMessage = error.message ?? "Unknown error";
				console.error("Unexpected consolidated refine request error:", error);
			}

			consolidatedHasError = true;
			} finally {
				clearTimeout(refineTimeout);
			}
		}

		// const finalParts = Array.isArray(refinedData.parts) && refinedData.parts.length > 0
		// 	? refinedData.parts
		// 	: sanitisedCandidateData.parts;
		// NO fallback to candidate parts if no refined parts found
		const finalParts = refinedData.parts

		return Promise.resolve({
			numberOfCases: sanitisedCandidateData.numberOfCases,
			casesList: sanitisedCandidateData.casesList,
			parts: finalParts,
			bf_links: sanitisedCandidateData?.bf_links ?? null,
			candidates: sanitisedCandidateData,
			refined: refinedData.parts ?? [],
			refineQueries: refineTokens,
			isError: consolidatedHasError,
			errorMessage: consolidatedErrorMessage,
			emptyTraceback: "",
		});
	};


	//Queries Bloomfire API for serial number, search result, etc.
	const queryToBF = async (query) => {
		try {
			const response = await api.get(`/api/query/bloomfire/${query}`);
			if(response.data.status_code === 200) {
				setSearchResultsBF(response.data.posts);
			} else {
				setSearchResultsBF({});
			};
		} catch (error) {
			if (error.response) {
				// The request was made and the server responded with a status code
				// that falls out of the range of 2xx
				console.error('Error response:', error.response);
			} else if (error.request) {
				// The request was made but no response was received
				console.error('Error request:', error.request);
			} else {
				// Something happened in setting up the request that triggered an Error
				console.error('Error message:', error.message);
			}
		}
	}


	//Searches for parts from serial Numbers via resolved cases
	const snToPartsRC = async (ser_num, mod_num, manName, refine_query) => {
		// URL encodes the inputs
		const enc_ser_num = encodeURIComponent(ser_num);
		const enc_mod_num = encodeURIComponent(mod_num);
		const enc_mfg_name = encodeURIComponent(manName);
		const enc_refine_query = encodeURIComponent(refine_query);

		try {
			const source = axios.CancelToken.source();
			const timeout = setTimeout(() => {
				source.cancel();
			}, 10000);
			const response = await api.get(`/api/partsRes/?ser_num=${enc_ser_num}&mod_num=${enc_mod_num}&mfg_name=${enc_mfg_name}&refine_query=${enc_refine_query}`);
			clearTimeout(timeout);
			// Returns result for logging
			return Promise.resolve({
				parts: response.data.parts,
				numberOfCases: response.data.numberOfCases,
				casesList: response.data.casesList,
				isError: false,
				errorMessage: "",
				emptyTraceback: response.data.emptyTraceback
			});
		} catch (error) {

			// Value to return in the promise
			var retPartRCData = {};
			var errorMessage = "Unknown error";
			
			// Either the formatted error response in renderData
			// or an empty list if the request timed out (since backend then didn't return a response for us to use)
			if (axios.isCancel(error)) {
				retPartRCData  = {"": []};
				errorMessage = "Request timed out";
			} else {
				retPartRCData = error.response.data.detail.renderData;
				errorMessage = error.response.data.detail.message;
				
			}

			if (error.response) {
				// The request was made and the server responded with a status code
				// that falls out of the range of 2xx
				console.error('Error response:', error.response);
			} else if (error.request) {
				// The request was made but no response was received
				console.error('Error request:', error.request);
			} else {
				// Something happened in setting up the request that triggered an Error
				console.error('Error message:', error.message);
			}
			
			// Returns empty results for logging
			return Promise.resolve({
				parts: retPartRCData?.parts,
				numberOfCases: retPartRCData?.numberOfCases,
				casesList: retPartRCData?.casesList,
				isError: true,
				errorMessage: errorMessage,
				emptyTraceback: error.response.data.detail.renderData.emptyTraceback
			});
		} finally {
			console.log("RC Returned")
		}
	};


	//Searches for parts from serial Numbers via serial number lookup
	const snToPartsSNL = async (ser_num, mod_num, manName, refine_query) => {
		// URL encodes the inputs
		ser_num = encodeURIComponent(ser_num);
		refine_query = encodeURIComponent(refine_query);
		manName = encodeURIComponent(manName);

		try {
			const source = axios.CancelToken.source();
			const timeout = setTimeout(() => {
				source.cancel();
			}, 10000);
			const response = await api.get(`/api/partsSNL/?ser_num=${ser_num}&mod_num=${mod_num}&mfg_name=${manName}&refine_query=${refine_query}`);
			
			clearTimeout(timeout);
			// console.log("SNL Returned is ", response.data.parts);
			return Promise.resolve({
				parts: response.data.parts,
				isError: false,
				errorMessage: "",
				emptyTraceback: response.data.emptyTraceback
			});
		} catch (error) {
			// Value to return in the promise
			var retPartSNLData = {};
			var errorMessage = "Unknown error";
			// Either the formatted error response in renderData.parts
			// or an empty list if the request timed out (since backend then didn't return a response for us to use)
			if (axios.isCancel(error)) {
				retPartSNLData = {"": []};
				errorMessage = "Request timed out";
			} else {
				retPartSNLData = error.response.data.detail.renderData.parts;
				errorMessage = error.response.data.detail.message;
			}

			if (error.response) {
				// The request was made and the server responded with a status code
				// that falls out of the range of 2xx
				console.error('Error response:', error.response);
			} else if (error.request) {
				// The request was made but no response was received
				console.error('Error request:', error.request);
			} else {
				// Something happened in setting up the request that triggered an Error
				console.error('Error message:', error.message);
			}

			// Returns an error to end the async function
			// Returns empty results for logging
			return Promise.resolve({
				parts: retPartSNLData,
				isError: true,
				errorMessage: errorMessage,
				emptyTraceback: error.response.data.detail.renderData.emptyTraceback
			});
		} finally {
			console.log("SNL Returned")
		}
	};

	// NEW: Searches for parts from serial Numbers via website data
	const snToPartsWebsite = async (ser_num, mod_num, manName, refine_query) => {
		// URL encodes the inputs
		mod_num = encodeURIComponent(mod_num);
		manName = encodeURIComponent(manName);
		refine_query = encodeURIComponent(refine_query);
	
		try {
			const source = axios.CancelToken.source();
			const timeout = setTimeout(() => {
				source.cancel();
			}, 10000);
			
	
			// Model number calling to partsWebsite endpoint (implement when Edward done with endpoint)
			const response = await api.get(`/api/partsWeb/?ser_num=${ser_num}&mod_num=${mod_num}&mfg_name=${manName}&refine_query=${refine_query}`);

			clearTimeout(timeout);
			// return Promise.resolve(response.data.parts);
			console.log("Response data: ", response.data);
			return Promise.resolve ({
				parts: response.data.parts,
				isError: false,
				errorMessage: "",
				emptyTraceback: response.data.emptyTraceback
			});
		} catch (error) {
			// Value to return in the promise
			var retPartWebsiteData = {};
			var errorMessage = "Unknown error";
			
			// Either the formatted error response in renderData.parts
			// or an empty list if the request timed out (since backend then didn't return a response for us to use)
			if (axios.isCancel(error)) {
				retPartWebsiteData = {"": []};
				errorMessage = "Request timed out";
			} else {
				retPartWebsiteData = error.response.data.detail.renderData.parts;
				errorMessage = error.response.data.detail.message;
			}
	
			if (error.response) {
				// The request was made and the server responded with a status code
				// that falls out of the range of 2xx
				console.error('Error response:', error.response);
			} else if (error.request) {
				// The request was made but no response was received
				console.error('Error request:', error.request);
			} else {
				// Something happened in setting up the request that triggered an Error
				console.error('Error message:', error.message);
			}
			
			// Returns an error to end the async function
			// Returns empty results for logging
			// return Promise.reject(retPartWebsiteData);
			return Promise.resolve ({
				parts: retPartWebsiteData,
				isError: true,
				errorMessage: errorMessage,
				emptyTraceback: error.response.data.detail.renderData.emptyTraceback
			});
		} finally {
			console.log("Website Returned")
		}
	};

	// API function for parsed parts from PDF manuals
	const snToPartsParsed = async (ser_num, mod_num, manName, refine_query) => {
		// URL encodes the inputs
		mod_num = encodeURIComponent(mod_num);
		manName = encodeURIComponent(manName);
		refine_query = encodeURIComponent(refine_query);
	
		try {
			const source = axios.CancelToken.source();
			const timeout = setTimeout(() => {
				source.cancel();
			}, 10000);
			
			// Model number calling to partsParsed endpoint
			const response = await api.get(`/api/partsParsed/?ser_num=${ser_num}&mod_num=${mod_num}&mfg_name=${manName}&refine_query=${refine_query}`);

			clearTimeout(timeout);
			console.log("Parsed response data: ", response.data);
			return Promise.resolve ({
				parts: response.data.parts,
				isError: false,
				errorMessage: "",
				emptyTraceback: response.data.emptyTraceback
			});
		} catch (error) {
			// Value to return in the promise
			var retPartParsedData = {};
			var errorMessage = "Unknown error";
			
			// Either the formatted error response in renderData.parts
			if (error.response && error.response.data && error.response.data.detail && error.response.data.detail.renderData) {
				retPartParsedData = error.response.data.detail.renderData.parts;
				errorMessage = error.response.data.detail.renderData.errorMessage;
			}
			
			if (error.response) {
				// The request was made and the server responded with a status code
				// that falls out of the range of 2xx
				console.error('Error response:', error.response);
			} else if (error.request) {
				// The request was made but no response was received
				console.error('Error request:', error.request);
			} else {
				// Something happened in setting up the request that triggered an Error
				console.error('Error message:', error.message);
			}
			
			// Returns an error to end the async function
			// Returns empty results for logging
			return Promise.resolve ({
				parts: retPartParsedData,
				isError: true,
				errorMessage: errorMessage,
				emptyTraceback: error.response.data.detail.renderData.emptyTraceback
			});
		} finally {
			console.log("Parsed Returned")
		}
	};




	//Prints number of API calls ongoing/left to go
	useEffect(() => {
		console.log("IsLoading (i.e. current number of API fetches): ", isLoading);
	}, [isLoading]);

	//Prints the results as they arrive
	// useEffect(() => {
	//	 console.log("Search Parts are: ", searchResultsParts);
	// }, [searchResultsParts]);
	useEffect(() => {
		console.log("Search Manuals are: ", searchResultsManuals);
	}, [searchResultsManuals]);
	useEffect(() => {
		console.log("Search Parts Resolved are: ", searchResultsPartsRC);
	}, [searchResultsPartsRC]);
	useEffect(() => {
		console.log("Search Parts SNL are: ", searchResultsPartsSNL);
	}, [searchResultsPartsSNL]);

	// Add useEffect to log Website Lookup results
	useEffect(() => {
		console.log("Search Parts Website are: ", searchResultsPartsWebsite);
	}, [searchResultsPartsWebsite]);
	useEffect(() => {
		console.log("Consolidated Parts are: ", searchResultsPartsAll);
	}, [searchResultsPartsAll]);

	useEffect(() => {
		console.log("Just performed search: ", searchId);
	}, [searchId]);


	

	return (
		<AppContext.Provider value={{
			manList,
			searchResultsManuals,
			setSearchResultsManuals,
			searchResultsManualsTraceback,
			setSearchResultsManualsTraceback,
			// searchResultsParts,
			// setSearchResultsParts,
			searchResultsBF,
			setSearchResultsBF,
			searchResultsBFTraceback,
			setSearchResultsBFTraceback,
			isLoading,
			setIsLoading,
			keepSRBlank,
			setKeepSRBlank,
			isConsolidatedLoading,
			setIsConsolidatedLoading,
			resultsViewMode,
			setResultsViewMode,
			activeFilter,
			setActiveFilter,
			activeSearchTermFilter,
			setActiveSearchTermFilter,
			snToManuals,
			// Inputs
			serNum,
			setSerNum,
			modNum,
			setModNum,
			manName,
			setManName,
			refineQuery,
			setRefineQuery,
			// snToParts,
			queryToBF,
			snToPartsRC,
			logFeedbackHandler,
			logSearchHandler,
			logResultsHandler,
			searchResultsPartsRC,
			setSearchResultsPartsRC,
			searchResultsPartsRCTraceback,
			setSearchResultsPartsRCTraceback,
			searchResultsPartsSNL,
			setSearchResultsPartsSNL,
			searchResultsPartsSNLTraceback,
			setSearchResultsPartsSNLTraceback,
			snToPartsSNL,
			// WEBSITE ----
			searchResultsPartsWebsite,
			setSearchResultsPartsWebsite,
			searchResultsPartsWebsiteTraceback,
			setSearchResultsPartsWebsiteTraceback,
			snToPartsWebsite,
			// Parsed parts data
			searchResultsPartsParsed,
			setSearchResultsPartsParsed,
			searchResultsPartsTraceback,
			setSearchResultsPartsTraceback,
			snToPartsParsed,
			searchResultsPartsAll,
			setSearchResultsPartsAll,
			searchResultsPartsAllTraceback,
			setSearchResultsPartsAllTraceback,
			snToPartsAll,
			// ------------
			setSearchId,
			feedbackPanelStatesRC,
			setFeedbackPanelStatesRC,
			handleFeedbackPanelStatesRC,
			feedbackPanelStatesSNL,
			setFeedbackPanelStatesSNL,
			handleFeedbackPanelStatesSNL,
		feedbackPanelStatesWeb,
		setFeedbackPanelStatesWeb,
		handleFeedbackPanelStatesWeb,
		feedbackPanelStatesParsed,
		setFeedbackPanelStatesParsed,
		handleFeedbackPanelStatesParsed,
		feedbackPanelStatesAll,
		setFeedbackPanelStatesAll,
		handleFeedbackPanelStatesAll
	}}>
			{children}
		</AppContext.Provider>
	);
};
